export const TITLE = "My trips";
export const SUBTITLE = "View and manage upcoming and past trips";
export const FAQ_TITLE = "Questions about your trip?";
export const FAQ_CTA = "View FAQs";
export const SUPPORT_CTA = "Contact support";

export const CONTACT_SUPPORT_HEADER = "Contact support";
export const CONTACT_SUPPORT_TEXT =
  "For any questions regarding your trip, please contact our support team and we'd be happy to help.";
export const CONTACT_SUPPORT_NUMBER = "844-422-6922";

export const SEARCH = "Search";
export const REDESIGN_SUBTITLE = "View and manage upcoming and past trips.";

export const CONTACT_F9_SUBTITLE =
  "Your booking is managed by the airline. To change, cancel, or modify your flight, contact Frontier directly or visit their website.";
